import React, { useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Image, Button, Form } from "react-bootstrap";
import "./Selection.css";
import HeaderB from "../../components/headerb/HeaderB";
import Bselect from "./Bselect";
import { MainContext } from "../../contexts/MainContext";

export default function Selection() {
  let { setZayechB, setZayechC, setQuestionIdCon, setLotNameCon, setTitleIdCon } = useContext(MainContext);

  const mainContext = useContext(MainContext);
  useEffect(() => {
    mainContext.setSecondSelectDisabled(true);
    localStorage.removeItem("mainObj2");
    localStorage.removeItem("mainObject");

    setZayechB([]);
    setZayechC([]);
    setQuestionIdCon("");
    setLotNameCon("");
    setTitleIdCon("");
  }, []);
  return (
    <>
      <Container fluid>
        <HeaderB />
      </Container>

      <Container>
        <br />
        <br />
        <Row className="justify-content-md-center">
          <Col xs={12} md={6}>
            <Image center className="welcome-image" src="./images/image21.jpg" alt="توضیحات" thumbnail style={{ border: "none" }} />
          </Col>

          <Col xs={8} md={4}>
            <Bselect />
          </Col>
        </Row>
      </Container>
    </>
  );
}
